import { useDispatch } from "react-redux";
import { resetStore } from "Redux/store";

export const useResetStore = () => {
  const dispatch = useDispatch();

  const resetStore = () => {
    dispatch(resetStore());
  };

  return resetStore;
};
